<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 22 25"
    id="icon-xing"
    :width="width"
    :height="height"
    :fill="fill"
    aria-hidden="true"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.75285 5.13428L4.58253 10.1503L0.351562 17.5485H5.39543L9.59853 10.1503L6.76808 5.13428H1.75285Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.771 0.5L8.61328 14.9341L13.8732 24.5H18.9937L13.6486 14.9341L21.8071 0.5H16.771Z"
    />
  </svg>
</template>

<script>
import { iconPropsFunc } from "../mixins/icons";

export default {
  name: "IconXing",
  mixins: [iconPropsFunc()],
};
</script>

<style lang="scss" scoped></style>
